import { NamePath } from '@xbcb/ui-types';
import { FormInstance } from 'antd';
import { calculateValuePerUnit } from 'libs/calculateValuePerUnit';

export const setProductUnitQuantity = ({
  form,
  productNamePath,
  uomIdx,
  unitReportingQuantity,
  quantity,
  totalReportingQuantity,
  realTariffIndex,
}: {
  form: FormInstance;
  productNamePath: NamePath;
  uomIdx: number;
  unitReportingQuantity?: number;
  quantity?: number;
  totalReportingQuantity?: number;
  realTariffIndex?: number;
}): void => {
  const unitValue =
    unitReportingQuantity ||
    calculateValuePerUnit({
      quantity,
      total: totalReportingQuantity,
    });
  if (unitValue !== undefined && realTariffIndex !== undefined) {
    const unitReportingQuantityNamePath = [
      ...productNamePath,
      'lines',
      0,
      'tariffs',
      realTariffIndex,
      'unitReportingQuantities',
      uomIdx,
      'value',
    ];
    form.setFieldValue(unitReportingQuantityNamePath, unitValue);
  }
};
